import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import configService from 'src/services/configService';
import { TopBar } from 'src/submodules/ui-components';
import Apps from 'src/submodules/ui-components/TopBar/Apps';
import Language from 'src/submodules/ui-components/TopBar/Language';
import Settings from 'src/submodules/ui-components/TopBar/Settings';
import Account from 'src/submodules/ui-components/TopBar/Account';
import TimeZone from 'src/submodules/ui-components/TopBar/TimeZone';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [webApps, setWebApps] = useState(configService.getWebApps());
  const items = [  //top bar items 
                  <Apps webApps={webApps}/>,
                  <TimeZone />,
                  <Language />,
                  <Settings />,
                  <Account />
                ]
  return (
    <div className={classes.root}>
      <TopBar 
        onMobileNavOpen={() => setMobileNavOpen(true)} 
        items={items}
      />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
